import Icon from '../../Icon/Icon';
import { IconKeys } from '../../Icon/IconKeys';
import Props from './types';
import S from './CollapsedEventStyles';

function CollapsedEvents({ count, expandable = true }: Props):JSX.Element {
  return (
    <S.Wrapper>
      <Icon iconKey={IconKeys.ALERT} />
      <p>{count}</p>
      {expandable && (
        <Icon iconKey={IconKeys.ARROW_DOWN} className="arrowDown" />
      )}
    </S.Wrapper>
  );
}

export default CollapsedEvents;
